export const SOFTLINE_FEATURE_LAGERSTAND = 'lagerstand';

export const SOFTLINE_PERMISSION_LAGERSTAND = 'SOFTAPPS.LAGER.LAGERSTAND';
